import React from "react";
import { PAGE } from "../../constants/page";
import { ContentItem } from "../content-Item";
import { Pagination } from "../pagination";
import "./index.scss";

export interface ContentListPaginationParams {
  filteredPosts: Queries.MarkdownRemarkEdge[];
  paginationRange: (string | number)[] | undefined;
  currentPage: number;
  handlePageChange: (newCurrent: number) => void;
}

export const ContentListPagination = ({
  filteredPosts,
  paginationRange,
  currentPage,
  handlePageChange,
}: ContentListPaginationParams) => {
  const firstPageIndex = (currentPage - 1) * PAGE.pageSize;
  const lastPageIndex = firstPageIndex + PAGE.pageSize;
  let finalPosts = filteredPosts.slice(firstPageIndex, lastPageIndex);

  let noPosts = filteredPosts?.length === 0;

  return (
    <div>
      <div>
        <p className="listTitle">Total of {filteredPosts?.length} posts</p>
        {noPosts ? (
          <div className="emptyContainer">There are no posts to display. </div>
        ) : (
          <>
            {finalPosts.map((post, index) => (
              <ContentItem key={index} index={index} post={post} />
            ))}
          </>
        )}
      </div>
      <Pagination
        paginationRange={paginationRange}
        currentPage={currentPage}
        handlePageChange={handlePageChange}
      />
    </div>
  );
};
